function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m11.33 11.465 6.395-6.755c.176-.187.276-.44.276-.703 0-.263-.1-.516-.276-.702a.928.928 0 0 0-1.33 0L10 10.06 3.605 3.305a.928.928 0 0 0-1.33 0 1.022 1.022 0 0 0-.276.702c0 .264.1.516.276.703l6.395 6.755-6.395 6.755a1.022 1.022 0 0 0-.276.703c0 .263.1.516.276.702a.928.928 0 0 0 1.33 0L10 12.87l6.395 6.755a.907.907 0 0 0 .908.257.968.968 0 0 0 .665-.702 1.032 1.032 0 0 0-.243-.96l-6.395-6.755z",
  fill: "#000",
  fillRule: "nonzero"
});
const SvgCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cross.751e7639.svg";
export { ForwardRef as ReactComponent };